var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDramIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.64524 6.97188H11.5V7.10669H9.64524H9.14524V7.60669V9.06118V9.56118H9.64524H11.5V9.71196H9.64524H9.14524V10.212V13.5H8.48305V10.164V9.66401H7.98305H6.05133V9.51322H7.92147H8.42147V9.01322V7.55874V7.05874H7.92147H6.05133V6.97188H7.92147H8.42147V6.47188V4.87355C8.42147 3.66393 8.14547 2.66705 7.51488 1.97064C6.87929 1.26871 5.961 0.956431 4.86084 0.95316C4.35015 0.919441 3.8387 0.999281 3.36092 1.18694C2.87758 1.37678 2.44091 1.67214 2.08008 2.05159L2.05165 2.0815L2.0285 2.11565C1.4811 2.92345 1.18109 3.87681 1.15858 4.85306H0.501855C0.531198 3.72655 0.907701 2.63685 1.57898 1.74744C2.48461 0.955622 3.62386 0.516128 4.8025 0.500435C5.98287 0.48472 7.13399 0.894952 8.05929 1.66437C8.8252 2.58425 9.21736 3.78277 9.14609 5.00426L9.14524 5.01881V5.03338V6.47188V6.97188H9.64524Z",
    fill: "#272727",
    stroke: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDramIc);
export default __webpack_public_path__ + "static/media/dram_ic.203a8e94d4e7dc3060298865c1005782.svg";
export { ForwardRef as ReactComponent };